import cls from "classnames";

import React from "react";

import { Close } from "@mui/icons-material";
import {
  Button,
  ClickAwayListener,
  Fade,
  IconButton,
  Paper,
  Popper,
  Typography,
} from "@mui/material";

import useEvent from "@/hooks/useEvent";

import { useFilterContext } from "../FilterContext";
import { getFilterConfigByKey } from "../filters";
import { FilterData } from "../typing";

export default function FilterPopper(
  props: React.PropsWithChildren<{ padding: boolean; isAll: boolean }>
) {
  const { open, anchorEl, setOpen, fieldId, resetFilterData, resetFilterField } =
    useFilterContext();

  const handleClear = useEvent(() => {
    props.isAll ? resetFilterData() : resetFilterField(fieldId as keyof FilterData);
  });

  return (
    <ClickAwayListener
      onClickAway={() => {
        setOpen(false);
      }}
    >
      <Popper
        id="popperId"
        keepMounted
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        className="IPopover"
        transition
        modifiers={[
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              altAxis: true,
              altBoundary: true,
              tether: false,
              rootBoundary: "document",
            },
          },
          {
            name: "computeStyles",
            options: {
              roundOffsets: ({ x, y }: { x: number; y: number }) => ({
                x: x,
                y: Math.round(y + 36),
              }),
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <div className={cls("min-w-[400px] mt-[-1px]")}>
                <div className="flex justify-between items-center py-[10px] px-[20px]">
                  <Typography color="textPrimary" className="!text-[20px]">
                    {props.isAll ? "All Filters" : getFilterConfigByKey(fieldId)?.label}
                  </Typography>
                  <IconButton onClick={() => setOpen(false)}>
                    <Close />
                  </IconButton>
                </div>
                <div
                  style={{
                    maxHeight: "calc(100vh - 320px)",
                    overflowY: "auto",
                  }}
                  className={`${props.padding ? "px-[20px]" : ""}`}
                >
                  {props.children}
                </div>
                <div className="text-right py-[3px] px-[20px]">
                  <Button
                    variant="text"
                    onClick={handleClear}
                    sx={{
                      textTransform: "capitalize",
                    }}
                  >
                    clear
                  </Button>
                </div>
              </div>
            </Paper>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  );
}
